import { AfterViewInit, Component, ContentChildren, ElementRef, EventEmitter, Input, OnDestroy, Output, QueryList, TemplateRef, ViewChild } from "@angular/core";
import { PrimeTemplate } from "primeng/api";
import { SelectorItem } from "ng/src/app/shared/item-selectors/item-selector.model";
import { Table } from "primeng/table";
import { ResizeObserverHelper } from "ng/src/app/core/resize-observer-helper";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
	selector: 'lb-paneled-viewer',
	templateUrl: 'paneled-viewer.component.html',
	styleUrls: ['paneled-viewer.component.scss']
})
export class PaneledViewerComponent<T = any> implements AfterViewInit, OnDestroy {
	@ViewChild('containerEl') containerEl?: ElementRef<HTMLElement>;
	
	@Input()
	items: SelectorItem<T>[] = [];
	
	@Input()
	loading = false;
	
	@Input()
	get selected() {
		return this._selected;
	}
	set selected(val) {
		this._selected = val;
		this.selectedChange.emit(val);
	}
	
	@Input()
	resizeWidth = 768;
	
	panelMode: 'single' | 'dual' = 'dual';
	
	@Output()
	selectedChange = new EventEmitter<T>();
	
	@ViewChild('defaultListTable')
	table!: Table;
	
	@ContentChildren(PrimeTemplate)
	templates!: QueryList<any>;
	
	selectorTemplate: TemplateRef<any> | null = null;
	emptyTemplate: TemplateRef<any> | null = null;
	contentTemplate: TemplateRef<any> | null = null;
	captionTemplate: TemplateRef<any> | null = null;
	headerTemplate: TemplateRef<any> | null = null;
	
	private _selected?: any;
	private destroy$ = new Subject();
	
	constructor() {}
	
	ngAfterViewInit(): void {
		setTimeout(() => {
			this.templates.forEach(item => {
				switch (item.getType()) {
					case 'selector':
						this.selectorTemplate = item.template;
						break;
					case 'empty':
						this.emptyTemplate = item.template;
						break;
					case 'caption':
						this.captionTemplate = item.template;
						break;
					case 'header':
						this.headerTemplate = item.template;
						break;
					case 'content':
					default:
						this.contentTemplate = item.template;
				}
			})
			
			this.table.captionTemplate = this.captionTemplate as any;
			
			if (!this.containerEl) {
				console.error('Cannot find Container Element. Will not watch for resize.');
				return;
			}
			this.evaluateWidth(this.containerEl.nativeElement.getBoundingClientRect().width);
			ResizeObserverHelper.observe(this.containerEl.nativeElement).pipe(
					takeUntil(this.destroy$)
				)
				.subscribe(value => {
					if (!value) return;
					this.evaluateWidth(value.contentRect.width);
				});
		});
	}
	
	ngOnDestroy(): void {
		this.destroy$.next();
	}
	
	evaluateWidth(newWidth: number) {
		this.panelMode = newWidth >= this.resizeWidth ? 'dual' : 'single';
	}
	
	clearSelected() {
		this.selected = null;
	}
}
